import {
  addArticleOfferRequest,
  deleteArticleOfferRequest,
  editArticleOfferRequest,
  requestFetchArticles,
  requestFetchOffers
} from '@cbgms/api/modules/customers/requests'
import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'

interface ArticleOfferPayload {
  ArticleOfferUUId: string
  OfferDescription: string
  ValidForConcepts: string
  ValidFrom: string
  ValidTo: string
  MixFile: boolean
  MixingFromPosition: string
  File?: File
}
export interface DeleteArticleOfferResponse {
  Data: {
    Status: string
    Message: string
  }
}
export const fetchOffersCalled = (appId: string) => ({
  type: [types.GET_OFFERS, types.GET_OFFERS_SUCCESS, types.GET_OFFERS_FAILED],
  payload: {
    api: 'support',
    request: requestFetchOffers(appId)
  },
  Data: []
})

export const fetchArticles = (appId: string, articleOfferUuid: string) => ({
  type: [types.GET_ARTICLES, types.GET_ARTICLES_SUCCESS, types.GET_ARTICLES_FAILED],
  payload: {
    api: 'support',
    request: requestFetchArticles(appId, articleOfferUuid)
  },
  Data: []
})

export const deleteArticleOffer = (articleOfferUuid: string) => {
  return AsyncAction<DeleteArticleOfferResponse>({
    type: [types.DELETE_ARTICLE_OFFER, types.DELETE_ARTICLE_OFFER_SUCCESS, types.DELETE_ARTICLE_OFFER_FAILED],
    payload: {
      api: 'support',
      request: deleteArticleOfferRequest(articleOfferUuid)
    }
  })
}

export const addArticleOffer = (appId: string, payload: ArticleOfferPayload, createdByName: string, updatedByName: string) => ({
  type: [types.ADD_ARTICLE_OFFER, types.ADD_ARTICLE_OFFER_SUCCESS, types.ADD_ARTICLE_OFFER_FAILED],
  payload: {
    api: 'support',
    request: addArticleOfferRequest(appId, payload, createdByName, updatedByName)
  },
  Data: {}
})

export const editArticleOffer = (appId: string, payload: ArticleOfferPayload, createdByName: string, updatedByName: string) => ({
  type: [types.EDIT_ARTICLE_OFFER, types.EDIT_ARTICLE_OFFER_SUCCESS, types.EDIT_ARTICLE_OFFER_FAILED],
  payload: {
    api: 'support',
    request: editArticleOfferRequest(appId, payload, createdByName, updatedByName)
  },
  Data: {}
})
